module.exports = __webpack_public_path__ + "img/logout.c6e5f26d.png";